<template>
  <div class="row">
    <div class="small-12 medium-8 large-8 columns push-down">
      <div :style="petBackground" class="square pet-area">
        <label
          v-for="(item, index) in bodyPartsSortedList"
          :key="'pet-area-' + index"
          :for="'pet-area--' + item.Id"
          :class="'checkbox-button-no-check pet-area--' + [index + 1]"
        >
          <input
            :id="'pet-area--' + item.Id"
            v-model="selectedBodyDamageZones"
            :value="item"
            name="body-area"
            type="checkbox"
          />
          <span class="button primary">{{ index + 1 }}</span>
        </label>
      </div>
    </div>
    <div class="small-12 medium-4 large-4 columns">
      <ul class="no-bullet pet-parts-list">
        <li v-for="(item, index) in bodyPartsSortedList" :key="'body-part-' + index">
          <span @click="addOrRemove(item.Id)">{{ index + 1 }}. {{ item.Description }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Utility from '@/common/UtilityFunctions.js';
import { BodyPart } from '../types/BodyPart.types';
import { DataModel } from './PetBodyParts.types';

export default defineComponent({
  name: 'PetBodyParts',
  props: {
    modelValue: {
      type: Array as PropType<BodyPart[] | null>,
      default() {
        return [];
      }
    },
    bodyDamageList: {
      type: Array as PropType<BodyPart[]>,
      default() {
        return [];
      }
    }
  },
  data(): DataModel {
    return {
      selectedBodyDamageZones: []
    };
  },
  computed: {
    bodyPartsSortedList(): BodyPart[] {
      if (this.bodyDamageList.length > 0) {
        return this.bodyDamageList.slice().sort((a: any, b: any) => a.SortOrder - b.SortOrder);
      }
      return [];
    },
    petBackground() {
      return `background-image: url('/assets/portal/images/damagezones/${Utility.getBrandFolderName()}/Hund.svg`;
    }
  },
  watch: {
    selectedBodyDamageZones(val): void {
      this.$emit('update:modelValue', val);
    }
  },
  async mounted(): Promise<void> {
    await this.$nextTick();
    this.selectedBodyDamageZones = this.modelValue;
  },
  methods: {
    addOrRemove(value: number): void {
      const result = this.selectedBodyDamageZones?.findIndex((obj: BodyPart) => obj.Id === value);

      if (result === -1) {
        const o = this.bodyPartsSortedList.find((obj) => obj.Id === value);

        if (o !== undefined) {
          this.selectedBodyDamageZones?.push(o);
        }
      } else if (result !== undefined) {
        this.selectedBodyDamageZones?.splice(result, 1);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.square {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.checkbox-button-no-check {
  [type='checkbox'] {
    & + span {
      width: 27px;
      height: 27px;
      padding: 0 33% !important;
      font-size: $small-font-size;
    }

    &:checked {
      & + span {
        background-color: $secondary-color;
        opacity: 0.9;
      }
    }
  }
}

.pet-area {
  padding-bottom: 80%;

  > label {
    position: absolute;
    margin-left: -13.5px;
  }

  &--1 {
    top: 11%;
    left: 80%;
  }

  &--2 {
    top: 22%;
    left: 95%;
  }

  &--3 {
    top: 23%;
    left: 7%;
  }

  &--4 {
    top: 27%;
    left: 44%;
  }

  &--5 {
    top: 29%;
    left: 68%;
  }

  &--6 {
    top: 40%;
    left: 50%;
  }

  &--7 {
    top: 45%;
    left: 64%;
  }

  &--8 {
    top: 48%;
    left: 25%;
  }

  &--9 {
    top: 65%;
    left: 66%;
  }

  &--10 {
    top: 65%;
    left: 76%;
  }

  &--11 {
    top: 74%;
    left: 17%;
  }

  &--12 {
    top: 74%;
    left: 27%;
  }

  &--13 {
    top: 77%;
    left: 66%;
  }

  &--14 {
    top: 77%;
    left: 76%;
  }

  &--15 {
    top: 84%;
    left: 60%;
  }

  &--16 {
    top: 90%;
    left: 8%;
  }

  &--17 {
    top: 90%;
    left: 18%;
  }

  &--18 {
    top: 90%;
    left: 67%;
  }

  &--19 {
    top: 90%;
    left: 77%;
  }
}

.pet-parts-list {
  font-size: 90%;
  line-height: 1.4;

  span {
    cursor: pointer;
  }
}
</style>
